import React, { useEffect, useState } from "react";
import styles from "./LeadPopup.module.css";
import highPriorityIcon from "../FlagAssign/assets/High.svg";
import urgentPriorityIcon from "../FlagAssign/assets/Urgent.svg";
import normalPriorityIcon from "../FlagAssign/assets/Normal.svg";
import lowPriorityIcon from "../FlagAssign/assets/Low.svg";
import editIcon from "./Assets/edit-icon.svg";
import LeadDetailsEdit from "../../pages/app/Nurture/components/LeadExpand/LeadDetailsEdit";
import { WhatsApp } from "@mui/icons-material";
import LeadCallPopup from "./LeadCallPopup";
import { useAuthUser } from "react-auth-kit";
import { useSelector } from "react-redux";
import LeadPhoneChangeConfirmPopup from "./subComponents/LeadPhoneChangeConfirmPopup";
import LeadCallDispositionForm from "./subComponents/LeadCallDispositionForm";
import { Tooltip } from "@mui/material";
import { getSubDomainAccessStatus } from "../RolePermissionAccess/RolePermissionAccess";
import getTeamMember from "../CommonFunctions/CommonFunctions";
import DeleteBtn from "../Buttons/DeleteBtn";
import {
  deleteEntity,
  resetDeleteEntitySuccess,
} from "../../service/activeInstituteSlice";
import { useDispatch } from "react-redux";
import DeletePopup from "../CommonPopups/DeletePopup";
import AddLeadCardForUnknownLeads from "./subComponents/AddLeadCardForUnknownLeads";
import LeadCallDispositionFormForOzontel from "./subComponents/LeadCallDispositionFormForOzontel";
import LeadCallPopupForOzonetel from "./LeadCallPopupForOzontel";
import { getLeadAdditionalDetails } from "../../pages/app/Nurture/service/nurtureSlice";

function LeadDetailsTop(props: any) {
  const {
    leadById,
    employees,
    GetLeadById,
    UpdateLead,
    selectedLeadData,
    CallLead,
    taskTypes,
    leadListByContact,
    leadPopupApiCall,
    CallDispositionForm,
    ClearLeadPopupQuery,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission,
  );
  const hasLeadAccess = getSubDomainAccessStatus(
    "NURTURE_BOARD",
    "LEAD_CARD",
    "ALL_ACCESS",
    userById?.rolePermission,
  );

  const [isLeadEditOpen, setLeadEditOpen] = React.useState<boolean>(false);
  const [assignyId, setAssignyId] = useState<any>();
  const [editPriority, setEditPriority] = useState<any>();
  const [callDispositionShowStatus, setCallDispositionShowStatus] =
    useState<any>("");
  const [callUcid, setCallUcid] = useState<any>("");
  const [callDID, setCallDID] = useState<any>("");
  const { deleteEntitySuccess, deleteEntityLoading, deleteEntityError } =
    useSelector((state: any) => state.activeInstitute);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const activeInstitute = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const dispatch = useDispatch();

  const toggleLeadEditModal = () => {
    setLeadEditOpen(!isLeadEditOpen);
  };

  const openLeadEditModal = (
    leadId: number,
    assignyId: any,
    enquiryPriority: any,
  ) => {
    setLeadEditOpen(true);
    GetLeadById(leadId && leadId);
    setAssignyId(assignyId);
    setEditPriority(enquiryPriority);
  };

  const formatForWhatsApp = (countryCode: string, contact: string): string => {
    const digitsOnly = contact.replace(/\D+/g, "");
    const localNumber = digitsOnly.startsWith(countryCode)
      ? digitsOnly.replace(countryCode, "")
      : digitsOnly;
    return `${countryCode}${localNumber}`;
  };

  const ozonetelEmployee = employees?.find(
    (item: any) => item.employee === authUser?.institute[0]?.employee,
  );
  const hasOzonetelConfig = ozonetelEmployee?.ozonetelConfig !== undefined;
  const hasVoxbayConfig = ozonetelEmployee?.voxbayConfig !== undefined;

  const instituteData = useSelector(
    (state: any) => state.institute.instituteDetails,
  );

  const hasOzonetel =
    instituteData &&
    Array.isArray(instituteData.integrationsOpted) &&
    instituteData?.integrationsOpted?.includes("OZONETEL");

  const hasVoxbay =
    instituteData &&
    Array.isArray(instituteData.integrationsOpted) &&
    instituteData?.integrationsOpted?.includes("VOXBAY");

  const [phonePopup, setPhonePopup] = useState<boolean>(false);
  const [leadEdit, setLeadEdit] = useState<any>("");

  const onPhoneChangePopup = React.useCallback((leadData: any | null) => {
    setPhonePopup(true);
    setLeadEdit(leadData);
  }, []);

  const handlePhonePopupClose = () => {
    setPhonePopup(false);
    setLeadEdit("");
  };

  const handlePhoneChangeSubmit = async (event: any) => {
    event.preventDefault();

    try {
      UpdateLead(leadEdit);
    } catch (error) {}
  };

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const addLeadPayment = urlSearchParams.get("addLeadPayment");
    if (addLeadPayment === "true") {
      openLeadEditModal(
        selectedLeadData?.id,
        selectedLeadData?.assignedToId,
        selectedLeadData?.enquiryPriority,
      );
    }
  }, [selectedLeadData]);

  useEffect(() => {
    if (deleteEntitySuccess) {
      setShowDeletePopup(false);
      ClearLeadPopupQuery();
    }
  }, [deleteEntitySuccess]);

  useEffect(() => {
    if (deleteEntityError) {
      dispatch(resetDeleteEntitySuccess());
      setShowDeletePopup(false);
      // ClearLeadPopupQuery();
    }
  }, [deleteEntityError]);

  const handlePopupYesButton = () => {
    const body = {
      id: selectedLeadData?.id,
      operation: "ENQUIRY",
      instituteId: selectedLeadData?.instituteId,
      type: "lead",
    };
    dispatch<any>(deleteEntity(body));
  };

  const handlePopupNoButton = () => {
    setShowDeletePopup(false);
  };

  const allowRenderingOfOzonetel =
    (hasOzonetel && hasOzonetelConfig && selectedLeadData?.studentContact) ===
    true;

  const instituteFromRedux = useSelector(
    (state: any) => state.institute.instituteDetails,
  );

  const instituteCampaigns = instituteFromRedux?.ozonetelCampaigns?.message;

  const profilePic = useSelector(
    (state: any) =>
      state.nurture.leadAdditionalDetails?.additionalInfo?.find(
        (item: any) => item.fieldType === "profilePic",
      )?.fieldValue,
  );
  useEffect(() => {
    if (selectedLeadData?.id) {
      dispatch<any>(
        getLeadAdditionalDetails({
          leadId: selectedLeadData?.id,
          id: activeInstitute?.id,
        }),
      );
    }
  }, [selectedLeadData?.id]);

  return (
    <>
      <div className={styles.leadDetailsHead}>
        {selectedLeadData?.hasOwnProperty("leadProfileImage") && profilePic ? (
          <div className={styles.leadDetailsPic}>
            <img src={profilePic} alt="profile" />
          </div>
        ) : (
          <div className={styles.leadDetailsAvatar}>
            {selectedLeadData?.studentFirstName?.charAt(0) +
              selectedLeadData?.studentLastName?.charAt(0)}
          </div>
        )}

        <div className={styles.leadNameWrap}>
          {selectedLeadData?.studentFirstName !== undefined &&
          selectedLeadData?.studentLastName !== undefined ? (
            <div className={styles.leadName}>
              {`${selectedLeadData && selectedLeadData?.studentFirstName} ${
                selectedLeadData && selectedLeadData?.studentLastName
              }`}
            </div>
          ) : (
            ""
          )}

          <div>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {hasLeadAccess &&
                (hasAllBranchAccess ||
                  selectedLeadData?.branchId === userById?.branchId) && (
                  <button
                    className={styles.editBtn}
                    onClick={() =>
                      openLeadEditModal(
                        selectedLeadData.id,
                        selectedLeadData.assignedToId,
                        selectedLeadData.enquiryPriority,
                      )
                    }
                    disabled={!hasLeadAccess}
                  >
                    <img src={editIcon} alt="edit" />
                  </button>
                )}
              {(userById?.roleCode === "SUPER_ADMIN" ||
                userById?.roleCode === "ADMIN") && (
                <div>
                  <DeleteBtn
                    onClick={() => {
                      if (selectedLeadData?.canDelete === false) {
                        handlePopupYesButton();
                      } else {
                        setShowDeletePopup(true);
                      }
                    }}
                    disabled={
                      instituteData?.migrationStarted === true ||
                      instituteData?.isMigrated === true
                        ? true
                        : false
                    }
                  />
                </div>
              )}
            </div>
            {isLeadEditOpen && (
              <>
                <LeadDetailsEdit
                  toggleLeadEditModal={toggleLeadEditModal}
                  setLeadEditOpen={setLeadEditOpen}
                  isLeadEditOpen={isLeadEditOpen}
                  leadDetails={leadById && leadById}
                  users={employees && employees}
                  UpdateLead={UpdateLead}
                  assignyId={assignyId}
                  editDefaultPriority={editPriority}
                  onPhoneChangePopup={onPhoneChangePopup}
                  leadListByContact={leadListByContact}
                  leadPopupApiCall={leadPopupApiCall}
                />
              </>
            )}
            <LeadPhoneChangeConfirmPopup
              open={phonePopup}
              onClose={handlePhonePopupClose}
              yesButtonClick={handlePhoneChangeSubmit}
              leadEdit={leadEdit}
            />
          </div>
        </div>
        <div className={styles.leadStudentId}>
          {selectedLeadData?.studentId}
        </div>

        <div className={styles.leadContactDetails}>
          <div className={styles.leadContactRow}>
            <span>
              {selectedLeadData?.studentEmail}{" "}
              {selectedLeadData?.studentEmail &&
                selectedLeadData?.studentContact &&
                " | "}
              {selectedLeadData?.studentContact
                ? `+${selectedLeadData?.contactCountryCode || "91"} ${
                    selectedLeadData?.contactCountryCode
                      ? selectedLeadData?.studentContact?.replace(
                          selectedLeadData?.contactCountryCode,
                          "",
                        )
                      : selectedLeadData?.studentContact?.startsWith("91")
                        ? selectedLeadData?.studentContact?.replace("91", "")
                        : selectedLeadData?.studentContact
                  }`
                : null}
            </span>
            {hasVoxbay &&
              hasVoxbayConfig &&
              selectedLeadData?.studentContact && (
                <>
                  <LeadCallPopup
                    CallLead={CallLead}
                    selectedLeadData={selectedLeadData}
                    employees={employees}
                    setCallDispositionShowStatus={setCallDispositionShowStatus}
                    setCallUcid={setCallUcid}
                    setCallDID={setCallDID}
                  />
                </>
              )}
            {hasOzonetel &&
              hasOzonetelConfig &&
              selectedLeadData?.studentContact &&
              instituteCampaigns !== "no record found" && (
                <>
                  <LeadCallPopupForOzonetel
                    CallLead={CallLead}
                    selectedLeadData={selectedLeadData}
                    employees={employees}
                    setCallDispositionShowStatus={setCallDispositionShowStatus}
                    setCallUcid={setCallUcid}
                    setCallDID={setCallDID}
                  />
                </>
              )}
            {/* <LeadCallDispositionForm
              employees={employees}
              taskTypes={taskTypes}
              CallDispositionForm={CallDispositionForm}
              selectedLeadData={selectedLeadData}
              callDispositionShowStatus={callDispositionShowStatus}
              setCallDispositionShowStatus={setCallDispositionShowStatus}
              setCallUcid={setCallUcid}
              callUcid={callUcid}
              callDID={callDID}
              setCallDID={setCallDID}
            /> */}
            <LeadCallDispositionFormForOzontel
              employees={employees}
              taskTypes={taskTypes}
              CallDispositionForm={CallDispositionForm}
              selectedLeadData={selectedLeadData}
              callDispositionShowStatus={callDispositionShowStatus}
              setCallDispositionShowStatus={setCallDispositionShowStatus}
              setCallUcid={setCallUcid}
              callUcid={callUcid}
              callDID={callDID}
              setCallDID={setCallDID}
            />
            {/* <AddLeadCardForUnknownLeads /> */}
          </div>
        </div>
        <div className={styles.leadOtherDetailsWrap}>
          <div className={styles.leadSourceDetails}>
            Source:{" "}
            {selectedLeadData?.enquirySource?.toLowerCase().replace(/_/g, " ")}
          </div>
          <div className={styles.leadAssigneeDetails}>
            {getTeamMember(selectedLeadData?.assignedToId, employees)
              ?.firstName?.charAt(0)
              ?.toUpperCase()}
            {getTeamMember(selectedLeadData?.assignedToId, employees)
              ?.lastName?.charAt(0)
              ?.toUpperCase()}
          </div>
          {selectedLeadData?.enquiryPriority !== "" && (
            <div className={styles.leadAssigneeDetails}>
              <img
                src={
                  selectedLeadData?.enquiryPriority === "URGENT"
                    ? urgentPriorityIcon
                    : selectedLeadData?.enquiryPriority === "HIGH"
                      ? highPriorityIcon
                      : selectedLeadData?.enquiryPriority === "NORMAL"
                        ? normalPriorityIcon
                        : selectedLeadData?.enquiryPriority === "LOW"
                          ? lowPriorityIcon
                          : lowPriorityIcon
                }
                alt="priority"
              />
            </div>
          )}
          <div>
            {selectedLeadData &&
              selectedLeadData?.studentContact &&
              hasLeadAccess === true && (
                <a
                  href={`https://wa.me/${formatForWhatsApp(
                    selectedLeadData?.contactCountryCode || "91",
                    selectedLeadData?.studentContact,
                  )}`}
                  className={styles.leadWhatsApp}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsApp sx={{ fontSize: "34px" }} />
                </a>
              )}
          </div>
        </div>
        <div className={styles.leadOtherDetailsWrap}>
          <div
            className={styles.leadSourceDetails}
            style={{
              width: "250px",
              margin: "10px 0px",
              backgroundColor: "rgba(17, 200, 155, 0.1)",
              color: "#25d366",
              textTransform: "capitalize",
            }}
          >
            Tag:{" "}
            {selectedLeadData?.enquiryProfileTag
              ?.toLowerCase()
              ?.replace(/_/g, " ")}
          </div>
        </div>
        {/* <div className={styles.leadWhatsAppWrap}>
          {selectedLeadData &&
          selectedLeadData?.studentContact &&
          hasLeadAccess === true ? (
            <a
              href={`https://wa.me/${formatForWhatsApp(
                selectedLeadData?.contactCountryCode || "91",
                selectedLeadData?.studentContact
              )}`}
              className={styles.leadWhatsApp}
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsApp />
              Chat on WhatsApp
            </a>
          ) : (
            <Tooltip
              arrow
              title={
                hasLeadAccess === false
                  ? "Oops! No permission."
                  : "Add a valid phone number to use the WhatsApp services"
              }
              PopperProps={{ style: { zIndex: 999999 } }}
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#101828",
                    color: "#fff",
                    fontSize: "12px",
                    fontWeight: "500",
                    padding: "8px 12px",
                    zIndex: "999999",
                    "& .MuiTooltip-arrow": {
                      color: "#101828",
                      zIndex: "999999",
                    },
                  },
                },
              }}
            >
              <span>
                <div className={`${styles.leadWhatsApp} ${styles.disabled}`}>
                  <WhatsApp />
                  Chat on WhatsApp
                </div>
              </span>
            </Tooltip>
          )}
        </div> */}
      </div>
      {showDeletePopup && (
        <DeletePopup
          open={showDeletePopup}
          onClose={handlePopupNoButton}
          yesBtnClick={handlePopupYesButton}
          noBtnClick={handlePopupNoButton}
          loader={deleteEntityLoading}
          title={`Are you sure you want to delete this lead "${
            selectedLeadData?.studentFirstName
              ? selectedLeadData?.studentFirstName
              : ""
          } ${
            selectedLeadData?.studentLastName
              ? selectedLeadData?.studentLastName
              : ""
          }"?`}
        />
      )}
    </>
  );
}

export default LeadDetailsTop;
